import { atom } from 'recoil';

export const isLogined = atom({
  key: 'isLogin',
  default: false,
});